import { Bug } from "@styled-icons/boxicons-regular/Bug";
import { toggleErrorReporting } from "../../../VoiceChat/utils/sentry";
import { ReportIssueStyle } from "../style";

const ReportIssueButton = ({ onClick }) => (
  <ReportIssueStyle
    title="Something broken on this page? Let us know!"
    onClick={() => {
      onClick?.();
      toggleErrorReporting();
    }}
  >
    <Bug />
    <p>Report issue</p>
  </ReportIssueStyle>
);

export default ReportIssueButton;
